import {pushEdapEvent} from '../../utils/edap';

export function onViewMoreOrLessClick(isExpanded) {
    pushEdapEvent('interaction.selected', {
        action_location: 'collapsible-paragraph',
        event_category: 'interaction-click',
        event_action: isExpanded ? 'expand' : 'collapse',
        event_refinements: 'DEST_INTRO',
    });
}

export default onViewMoreOrLessClick;
